import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Banner from '../../atoms/Banner/Banner';
import ContentBox from '../../molecules/ContentBox';

const bd = {
  imgSrc: '/images/image/notice@2x.png',
  imgSrcM: '/images/image/noticeM@2x.jpeg',
  title: 'Notice',
  text1: 'We will guide you through major announcements on the BoB website.',
};

export default function NoticeDetailPage() {
  const { state } = useLocation();
  const classes = useStyles();

  const noticeData = state.data;

  const handleFile = (f) => {
    const a = document.createElement('a');
    a.href = process.env.PUBLIC_URL + f.src;
    a.download = f.name;
    a.click();
    a.remove();
  };

  const navigate = useNavigate();

  const handleListBtn = () => {
    navigate('/notice/list');
  };

  return (
    <Box className={classes.root}>
      <Banner bannerData={bd} />
      <ContentBox>
        <Box className={classes.board}>
          <Box className={classes.title}>{noticeData.title}</Box>
          <Box className={classes.etcBox}>
            <Box className={classes.etc}>
              <Box className={classes.writer}>Writer</Box>
              <Box className={classes.writerD}>{noticeData.writer}</Box>
            </Box>

            <Box className={classes.etc}>
              <Box className={classes.date}>Date</Box>
              <Box className={classes.dateD}>{noticeData.date}</Box>
            </Box>
          </Box>
          <Box className={classes.etc}>
            <Box className={classes.file}>File ({noticeData.file.length})</Box>
            <Box className={classes.files}>
              {noticeData.file.length !== 0 &&
                noticeData.file.map((f, i) => {
                  return (
                    <Box key={i} className={classes.fileD}>
                      <span className={classes.fileSpan} onClick={handleFile.bind(this, f)}>{`${f.name}`}</span>
                    </Box>
                  );
                })}
            </Box>
          </Box>

          <div className={classes.content} dangerouslySetInnerHTML={{ __html: noticeData.content }} />

          <Box className={classes.btnBox}>
            <button className={classes.listBtn} onClick={handleListBtn}>
              Back
            </button>
          </Box>
        </Box>
      </ContentBox>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {},
  board: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    '& > div': {
      // border: '1px solid',
    },
  },
  title: {
    borderTop: '1px solid',
    backgroundColor: 'rgb(229,230,234)',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    padding: '16px 16px',
    boxSizing: 'border-box',
    '@media only screen and (max-width: 768px)': {
      fontSize: '14px',
    },
  },
  //
  etcBox: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  etc: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    borderBottom: '1px solid rgb(234,233,234)',
  },
  writer: {
    display: 'flex',
    width: '30%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(245,246,249)',
    color: theme.color.black,
    padding: '16px 16px',
    boxSizing: 'border-box',
    '@media only screen and (max-width: 768px)': {
      fontSize: '12px',
    },
  },
  date: {
    display: 'flex',
    width: '30%',
    justifyContent: 'center',
    backgroundColor: 'rgb(245,246,249)',
    color: theme.color.black,
    padding: '16px 16px',
    boxSizing: 'border-box',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      fontSize: '12px',
    },
  },
  writerD: {
    display: 'flex',
    width: '70%',
    color: '#5a5a5a',
    padding: '16px 16px',
    boxSizing: 'border-box',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      fontSize: '12px',
    },
  },
  dateD: {
    display: 'flex',
    color: '#5a5a5a',
    padding: '16px 16px',
    boxSizing: 'border-box',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      width: '70%',
      fontSize: '12px',
    },
  },
  //
  file: {
    display: 'flex',
    width: '15%',
    justifyContent: 'center',
    backgroundColor: 'rgb(245,246,249)',
    color: theme.color.black,
    padding: '16px 16px',
    boxSizing: 'border-box',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      width: '30%',
      fontSize: '12px',
    },
  },
  files: {
    display: 'flex',
    width: '85%',
    boxSizing: 'border-box',
    flexDirection: 'column',
    maxHeight: '112px',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: '4px',
    '@media only screen and (max-width: 768px)': {
      width: '70%',
      paddingTop: '8px',
    },
  },
  fileD: {
    display: 'block',
    width: '100%',
    margin: '0 8px',
    padding: '12px 8px',
    color: '#5a5a5a',
    boxSizing: 'border-box',
    alignItems: 'center',
    '@media only screen and (max-width: 768px)': {
      padding: '4px 8px',
    },
  },
  fileSpan: {
    cursor: 'pointer',
    '&:hover': {
      color: '#0062AC',
      textDecoration: 'underline',
    },
    '@media only screen and (max-width: 768px)': {
      fontSize: '12px',
    },
  },
  //
  content: {
    boxSizing: 'border-box',
    padding: '16px 16px',
    borderBottom: '1px solid rgb(234,233,234)',
  },
  btnBox: {
    display: 'flex',
    width: '100%',
    padding: '16px 0px',
    boxSizing: 'border-box',
    justifyContent: 'flex-start',
  },
  listBtn: {
    backgroundColor: 'rgb(229,230,234)',
    width: '80px',
    height: '32px',
    border: '0',
    cursor: 'pointer',
    color: '#5a5a5a',
  },
}));
